import { FC } from "react";
import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import DiscountCodeForm from "../DiscountCodeCreate/partials/DiscountCodeForm";

import { useDiscountCodeEdit } from "./hooks";

const DiscountCodeEdit: FC = () => {
  const { form } = useDiscountCodeEdit();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Edit Discount Code" />
        </Typography.Title>
      </Header>
      <Space />
      <DiscountCodeForm {...form} />
    </>
  );
};

export default DiscountCodeEdit;
